import React from 'react';
import { Pressable, Text, View, StyleSheet } from 'react-native';
import { Paprika } from '../../../styles/theme';
import type { ConfigPhase } from '../../../redux/mealPlanUISlice';
import { useTranslation } from 'react-i18next';

interface Props {
  phase: ConfigPhase;
  selCount: number;
  onGenerate: () => void;
  onRegenerate: () => void;
  /** Leave the planner: aborts a running generation, or backs out of the settings. */
  onCancel: () => void;
}

export function ConfigActionBarM({ phase, selCount, onGenerate, onRegenerate, onCancel }: Props) {
  const { t } = useTranslation();
  const isGenerating = phase === 'thinking' || phase === 'cascade';

  return (
    <View style={styles.bar}>
      <Pressable style={styles.cancelBtn} onPress={onCancel} testID="config-cancel">
        <Text style={styles.cancelBtnText}>{t('common.cancel')}</Text>
      </Pressable>
      <Pressable
        style={[styles.generateBtn, (selCount === 0 || isGenerating) && styles.generateBtnDisabled]}
        onPress={onGenerate}
        disabled={selCount === 0 || isGenerating}
      >
        <Text style={styles.generateBtnText}>
          {isGenerating
            ? t('mealConfig.generating')
            : selCount === 0
            ? t('mealConfig.selectMeals')
            : t('mealConfig.generateSuggestion', { count: selCount })}
        </Text>
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  bar: {
    backgroundColor: Paprika.surfaceLowest,
    paddingHorizontal: 16,
    paddingVertical: 12,
    paddingBottom: 28,
    borderTopWidth: 1,
    borderTopColor: Paprika.border,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  cancelBtn: {
    borderRadius: 100,
    borderWidth: 1.5,
    borderColor: Paprika.border,
    paddingHorizontal: 18,
    paddingVertical: 13.5,
  },
  cancelBtnText: {
    fontFamily: 'Inter-Medium',
    fontSize: 15,
    color: Paprika.textSecondary,
  },
  generateBtn: {
    flex: 1,
    backgroundColor: Paprika.primary,
    borderRadius: 100,
    paddingVertical: 15,
    alignItems: 'center',
  },
  generateBtnDisabled: {
    opacity: 0.4,
  },
  generateBtnText: {
    fontFamily: 'Inter-SemiBold',
    fontSize: 15,
    color: '#fff',
  },
});
